export const UNKNOWN_CHANNEL = "unknown";
export const RENEW_CHANNEL = "renew";
export const DASHBOARD_CHANNEL = "dashboard";
export const GOODWILL_FUNNEL_CHANNEL = "goodwill_funnel";
export const JOURNEY_DETAILS_PAGE_UPGRADE = "journey_details_page_upgrade";
export const TRIP_ACTIVATION = "trip_activation";
export const BANNER_CHANNEL = "banner_complete";

export const COMPLETE_CHANNELS_REGEXP = /^.+_complete$/;
export const ESSENTIAL_CHANNELS_REGEXP = /^.+_essential$/;
